import { combineReducers, createStore } from 'redux'
import { IGlobalMessagingState } from 'types/globalMessaging'
import globalMessagingReducer from 'utils/reducers/globalMessaging'

// NOTE: this code is here just to initialize a store for the sake of the header
// TODO: find another way to get the header without having to init a redux store

export interface IStore {
  globalMessaging: IGlobalMessagingState
}

const reducers = combineReducers({
  globalMessaging: globalMessagingReducer,
})

export const configureStore = (preloadedState = {}) => {
  return createStore(reducers, preloadedState)
}
